import React from 'react';
import NoSleevesBase from './no-sleeves/Base';
import NoSleevesBaseWithDetail from './no-sleeves/BaseWithDetail';
import NoSleevesSplit from './no-sleeves/Split';
import NoSleevesSplitWithDetail from './no-sleeves/SplitWithDetail';
import NoSleevesStripes from './no-sleeves/Stripes';
import NoSleevesStripesWithDetail from './no-sleeves/StripesWithDetail';
import ShortSleevesBase from './short-sleeves/Base';
import ShortSleevesBaseWithDetail from './short-sleeves/BaseWithDetail';
import ShortSleevesSplit from './short-sleeves/Split';
import ShortSleevesSplitWithDetail from './short-sleeves/SplitWithDetail';
import ShortSleevesStripes from './short-sleeves/Stripes';
import ShortSleevesStripesWithDetail from './short-sleeves/StripesWithDetail';
import LongSleevesBase from './long-sleeves/Base';
import LongSleevesBaseWithDetail from './long-sleeves/BaseWithDetail';
import LongSleevesSplit from './long-sleeves/Split';
import LongSleevesSplitWithDetail from './long-sleeves/SplitWithDetail';
import LongSleevesStripes from './long-sleeves/Stripes';
import LongSleevesStripesWithDetail from './long-sleeves/StripesWithDetail';
import { BASKET, SOCCER } from '../../data/constants';
import SoccerDefaultHome from './short-sleeves/DefaultHome';
import SoccerDefaultAway from './short-sleeves/DefaultAway';
import BasketDefaultHome from './no-sleeves/DefaultHome';
import BasketDefaultAway from './no-sleeves/DefaultAway';

export default function Jersey(props) {
    const data = props.data;
    const sportRef = props.sportRef;
    const className = props.className || 'xs_jersey';
    const type = props.type;

    if (data == null) {
        if (sportRef === SOCCER) {
            return type === 'home' ? <SoccerDefaultHome className={className} /> : <SoccerDefaultAway className={className} />;
        } else if (sportRef === BASKET) {
            return type === 'home' ? <BasketDefaultHome className={className} /> : <BasketDefaultAway className={className} />;
        }
        return null;
    }

    const sleeve = data.sleeve != null ? data.sleeve : null;

    const id = `${type === 'home' ? 'h' : 'a'}_${data.id_competitor}`;

    const jerseyProps = {
        id: id,
        className: className,
        base: data.base,
        sleeve: sleeve
    };

    let Component = null;
    if (data.shirtType === 'long_sleeves') {
        if (data.splitColor != null) {
            if (data.sleeveDetail != null) {
                Component = LongSleevesSplitWithDetail;
                jerseyProps.detailColor = data.sleeveDetail;
            }
            Component = LongSleevesSplit;
            jerseyProps.splitColor = data.splitColor;
        } else if (data.stripesColor != null) {
            if (data.sleeveDetail != null) {
                Component = LongSleevesStripesWithDetail;
                jerseyProps.detailColor = data.sleeveDetail;
            }
            Component = LongSleevesStripes;
            jerseyProps.stripesColor = data.stripesColor;
        } else {
            if (data.sleeveDetail != null) {
                Component = LongSleevesBaseWithDetail;
                jerseyProps.detailColor = data.sleeveDetail;
            }
            Component = LongSleevesBase;
        }
    } else if (data.shirtType === 'no_sleeves' || (data.shirtType == null && data.sportRef === BASKET)) {
        if (data.splitColor != null) {
            if (data.sleeveDetail != null) {
                Component = NoSleevesSplitWithDetail;
                jerseyProps.detailColor = data.sleeveDetail;
            }
            Component = NoSleevesSplit;
            jerseyProps.splitColor = data.splitColor;
        } else if (data.stripesColor != null) {
            if (data.sleeveDetail != null) {
                Component = NoSleevesStripesWithDetail;
                jerseyProps.detailColor = data.sleeveDetail;
            }
            Component = NoSleevesStripes;
            jerseyProps.stripesColor = data.stripesColor;
        } else {
            if (data.sleeveDetail != null) {
                Component = NoSleevesBaseWithDetail;
                jerseyProps.detailColor = data.sleeveDetail;
            }
            Component = NoSleevesBase;
        }
    } else {
        if (data.splitColor != null) {
            if (data.sleeveDetail != null) {
                Component = ShortSleevesSplitWithDetail;
                jerseyProps.detailColor = data.sleeveDetail;
            }
            Component = ShortSleevesSplit;
            jerseyProps.splitColor = data.splitColor;
        } else if (data.stripesColor != null) {
            if (data.sleeveDetail != null) {
                Component = ShortSleevesStripesWithDetail;
                jerseyProps.detailColor = data.sleeveDetail;
            }
            Component = ShortSleevesStripes;
            jerseyProps.stripesColor = data.stripesColor;
        } else {
            if (data.sleeveDetail != null) {
                Component = ShortSleevesBaseWithDetail;
                jerseyProps.detailColor = data.sleeveDetail;
            }
            Component = ShortSleevesBase;
            jerseyProps.sleeve=sleeve
        }
    }

    return <Component {...jerseyProps} />;
}
